// Styles
import './style.css';

const Pasos = () => {
  const pasosItems = [
    {
      paso: '01',
      negrita: 'Seleccione',
      contenido: ' El seguro que buscas e ingresa tus datos.',
    },
    {
      paso: '02',
      negrita: 'Compara ',
      contenido: 'Resultados en menos de 3 minutos.',
    },
    {
      paso: '03',
      negrita: 'Asesoría',
      contenido: ' Te ayudamos a evaluar y sin ningún costo.',
    },
    {
      paso: '04',
      negrita: 'Contrata',
      contenido: ' Te acompañamos en la compra de tu seguro.',
    },
    {
      paso: '05',
      negrita: 'Administramos',
      contenido: ' Tu seguro, pagos y reclamos.',
    },
  ];

  return (
    <ul className="lista-pasos mt-5 fontPRegular">
      {pasosItems.map(paso => (
        <li key={paso.negrita} className="color-tertiary px-5 pt-6 pb-0">
          <div className="flex items-center gap-5 grid-pasos-mv">
            <span className="flex justify-center items-center circulo font-bold rounded-full  color-secondary bg-paso fill-primary text-center">
              {paso.paso}
            </span>
            <div className="text-left lg:text-base">
              <span className=" color-primary ">{paso.negrita}</span>
              {paso.contenido}
            </div>
          </div>

          <hr className="mt-6" />
        </li>
      ))}
    </ul>
  );
};

export default Pasos;
